import { parseJSON } from "date-fns";
import { BlockConfigurationObject } from "src/app/block-configuration-object.model";
import { Match } from "src/app/match.model";
import { BetService } from "src/app/bet.service";
import { GeneralService } from "src/app/general.service";
import { MatchService } from "src/app/match.service";
import { SportDataService } from "src/app/sport-data.service";
import { AfterContentChecked, Component, ElementRef, ErrorHandler, Input, OnChanges, OnInit, SimpleChanges,
	ViewChild, ViewEncapsulation, Inject } from "@angular/core";
import { environment } from "src/environments/environment";
import { faPlus } from "@fortawesome/pro-regular-svg-icons";
import { LocalisationService } from "src/app/localisation.service";
import { DOCUMENT } from "@angular/common";

@Component({
	selector: "app-match-best-bet-block",
	templateUrl: "./match-best-bet-block.component.html",
	styleUrls: ["./match-best-bet-block.component.scss"],
	encapsulation: ViewEncapsulation.None,
})
export class MatchBestBetBlockComponent implements OnInit, OnChanges, AfterContentChecked {

	@Input() configurationObject: BlockConfigurationObject;
	@ViewChild("blockBody") blockBody: ElementRef;

	awayBeforeHome = false;
	blockDomain = environment.blockDomain;
	bestBetError = false;
	bestParlayUnavailable = false;
	betType: string;
	displayMaximumWidths = {
		"x-compact": 350,
		compact: 500,
		"less-compact": 600,
		medium: 700,
		large: 800,
	};
	displayMode = "";
	gamesError = false;
	gamesLoading = true;
	match: Match = null;
	blockInitStarted = false;
	showBestParlay = false;

	faPlus = faPlus;

	constructor(
		private errorHandler: ErrorHandler,
		public matchService: MatchService,
		public sportDataService: SportDataService,
		public generalService: GeneralService,
		public betService: BetService,
		public localisationService: LocalisationService,
		private el: ElementRef,
		@Inject(DOCUMENT) public document: Document,
	) {}

	prepareBlock(): void {
		this.blockInitStarted = true;

		this.generalService.initialiseBlock(this.el);

		this.betType = this.configurationObject.betType;

		if (!this.betType) {
			this.betType = "overall";
		}

		if (!this.configurationObject.matchFirstTeam || this.configurationObject.matchFirstTeam === "away") {
			this.awayBeforeHome = true;
		}
		if (typeof window !== "undefined" && typeof document !== "undefined") {
			window.addEventListener("resize", this.checkCompact.bind(this));
		}

		this.matchService.getGeoData().then(() => {
			this.retrieveSingleGame(this.configurationObject.matchID || "");
		}, () => {
			this.retrieveSingleGame(this.configurationObject.matchID || "");
		});
	}

	ngOnInit(): void {
		if (this.configurationObject && !this.blockInitStarted) {
			this.prepareBlock();
		}

	}

	ngAfterContentChecked(): void {

		const element = this.el?.nativeElement;
		if (element && !this.displayMode) {
			this.displayMode = "full";
			Object.keys(this.displayMaximumWidths).forEach(level => {
				if (element && element.offsetWidth <= this.displayMaximumWidths[level]) {
					this.displayMode += ` ${level}`;
				}
			});
		}
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (!this.blockInitStarted && changes.configurationObject.currentValue) {
			this.prepareBlock();
		}
	}

	checkCompact(): void {
		let modeString = "full";
		const element = this.blockBody.nativeElement;
		if (element) {
			Object.keys(this.displayMaximumWidths).forEach(level => {
				if (element && element.offsetWidth <= this.displayMaximumWidths[level]) {
					modeString += ` ${level}`;
				}
			});
		}


		this.displayMode = modeString;
	};

	prepareMatchData = (): void => {
		try {


			this.match.MatchData.UserDate = parseJSON(this.match.MatchData.Date);

			if (this.betType !== "overall") {
				if (this.betType === "parlay") {
					this.showBestParlay = true;
					if (this.bestParlayUnavailable) {
						this.bestBetError = true;
					}
				} else {
					this.match.aggregatedBestBets = this.match.aggregatedBestBets.filter(b => b.type === this.betType);
					if (this.match.aggregatedBestBets.length === 0) {
						this.bestBetError = true;
					}
				}
			} else {
				this.match.aggregatedBestBets = this.match.aggregatedBestBets.sort((a,b) => b.edge - a.edge);
				if (this.match.aggregatedBestBets.length === 0) {
					this.bestBetError = true;
				}
			}

			this.gamesLoading = false;

		} catch (err) {
			this.errorHandler.handleError(err);

			this.gamesError = true;
		}
	};

	retrieveSingleGame = (matchid: string): void => {
		this.gamesLoading = true;
		this.gamesError = false;

		const sportCode = matchid.split("_")[0].toUpperCase();
		let bookmakerList: Array<string> = [];
		if (!sportCode.includes("|")
		&& this.configurationObject.sportExclusiveBookmakers
		&& Object.keys(this.configurationObject.sportExclusiveBookmakers).includes(sportCode.toUpperCase())) {
			bookmakerList = [this.configurationObject.sportExclusiveBookmakers[sportCode.toUpperCase()]];
		} else if (this.configurationObject.bookmakers) {
			bookmakerList = this.configurationObject.bookmakers;
		} else if (this.configurationObject.bookmakerThemeSportExceptions
			&& this.configurationObject.bookmakerThemeSportExceptions.includes(sportCode)) {
			bookmakerList = ["tab"];
		} else if (this.configurationObject.oddsProvider || this.configurationObject.bookmakerTheme) {
			bookmakerList = [this.configurationObject.oddsProvider || this.configurationObject.bookmakerTheme];
		}

		this.sportDataService.getPreMatchData(matchid, true, bookmakerList)
			.subscribe((match) => {
				this.match = match;

				this.prepareMatchData();
			}, () => {
				this.gamesError = true;
			});


	};

	reloadSingleGame = (matchID: string): void => {
		this.retrieveSingleGame(matchID);
	};
}
